import React from 'react';
import { Route, Switch } from 'react-router';
import { FullFooterLayout } from 'stash/components/app/Layouts';
import SignUpApp from 'stash/components/sign-up/SignUpApp';
import SignUpHelmet from 'stash/components/sign-up/SignUpHelmet';

class SignUpRouter extends React.Component {
	render() {
		return (
			<FullFooterLayout>
				<SignUpHelmet />
				<Switch>
					<Route path="/sign-up-:product/*" component={SignUpApp} />
					<Route path="/sign-up-:product" component={SignUpApp} />
				</Switch>
			</FullFooterLayout>
		);
	}
}

export default SignUpRouter;
